import { useEffect, useState } from 'react'

import { stateOptions } from '../../../../lib/systemData'
import DefaultUpdater from '../../../common/DefaultUpdater'
import Button from '../../../common/Button'

import classes from '../Shared/Item.module.css'

export default function EmployerInformation({data, apiCase}) {
    const [showData, setShowData] = useState(() => !data?.insurance_carrier_id)

    // Collapse by default when a carrier exists; do not re-collapse on each field save (data ref changes).
    useEffect(() => {
        if (data?.insurance_carrier_id) {
            setShowData(false)
        } else {
            setShowData(true)
        }
    }, [data?.insurance_carrier_id])

    function expandData() {
        setShowData((prev) => !prev)
    }

    return <>
        <h3 className={classes.group_header}>
            Employer information
            {data.insurance_carrier_id && <Button click={expandData} btnStyle={'btn_small'}>
                {showData && <>hide</>}
                {!showData && <>view</>}    
            </Button>}
        </h3>
        {showData && <div>
            <div className={`${classes.flex_container}`} style={{flex: 2}}>
                <DefaultUpdater type={'input'} value={data.employer_name} label={'Employer Name'} identifier={{type: apiCase, field: 'employer_name', folder: 'worker_comp'}} extraOptions={{minWidth: 250, redBorderFlag: (!data.insurance_carrier && !data.employer_name)}}/>

                <DefaultUpdater type={'input'} value={data.employer_phone} label={'Employer Phone'} identifier={{type: apiCase, field: 'employer_phone', folder: 'worker_comp'}} extraOptions={{format: 'phone', redBorderFlag: (!data.insurance_carrier && !data.employer_phone)}}/>

                <DefaultUpdater type={'input'} value={data.employer_phone_ext} label={'Ext'} identifier={{type: apiCase, field: 'employer_phone_ext', folder: 'worker_comp'}} />

                <DefaultUpdater type={'input'} value={data.employer_fax} label={'Employer Fax'} identifier={{type: apiCase, field: 'employer_fax', folder: 'worker_comp'}} extraOptions={{format: 'phone'}}/>

                <DefaultUpdater type={'input'} value={data.employer_email} label={'Employer Email'} identifier={{type: apiCase, field: 'employer_email', folder: 'worker_comp'}} />
            </div>
            <div className={`${classes.flex_container} ${classes.margin_top_12}`} style={{flex: 2}}>
                <DefaultUpdater type={'input'} value={data.employer_address} label={'Employer Address'} identifier={{type: apiCase, field: 'employer_address', folder: 'worker_comp'}} extraOptions={{minWidth: 250, redBorderFlag: (!data.insurance_carrier && !data.employer_address)}}/>

                <DefaultUpdater type={'input'} value={data.employer_city} label={'City'} identifier={{type: apiCase, field: 'employer_city', folder: 'worker_comp'}} />

                <DefaultUpdater type={'select'} value={data.employer_state} options={stateOptions()} label={'State'} identifier={{type: apiCase, field: 'employer_state', type_id: data.id, folder: 'worker_comp'}} extraOptions={{hasRemove: true, fixedDrawer: true}}/>

                <DefaultUpdater type={'input'} value={data.employer_zip} label={'Post Code'} identifier={{type: apiCase, field: 'employer_zip', folder: 'worker_comp'}} extraOptions={{format: 'zip'}}/>

                <DefaultUpdater type={'input'} value={data.employer_benefits_manager} label={'Benefits Manager'} identifier={{type: apiCase, field: 'employer_benefits_manager', folder: 'worker_comp'}} />
            </div>
        </div>}
    </>
}